import React, { Suspense } from "react";
import { useOutletContext } from "react-router-dom";

import NotFoundPage from "components/error/NotFoundPage";
import PageLoading from "components/loading/PageLoading";

import { IntegrationsOutletContext } from "../types";

const IntegrationDetails = () => {
  const { integration } = useOutletContext<IntegrationsOutletContext>();

  if (!integration?.hasViewScreen || !integration.detailsPage) {
    return <NotFoundPage />;
  }

  const DetailsPage = React.lazy(integration.detailsPage);

  return (
    <Suspense fallback={<PageLoading />}>
      <DetailsPage />
    </Suspense>
  );
};

export default IntegrationDetails;
